import { Heading } from '@circlefin/components'
import { useOnChainTransfer } from '@modals/blockchain'
import { FullScreen } from '@modals/layout'
import { TypeGuards } from '@services/type-guards'
import { Center } from '@shared/components/layout'
import useTranslation from 'next-translate/useTranslation'

import { useAceBlockchain } from '../../hooks'

import { SelectAmountForm } from './SelectAmount.Form'

export const SelectAmount: React.FC = () => {
  const { t } = useTranslation('ace')

  const [{ destination }] = useOnChainTransfer()

  const { aceBlockchain } = useAceBlockchain(destination?.chain)

  return (
    <FullScreen totalSteps={5}>
      <Center className="font-circular" variant="horizontal">
        <Heading alignment="center" variant="page/sm">
          <Heading.Header as="h2">
            {t('deposit.selectAmount.title')}
          </Heading.Header>
        </Heading>

        <Center variant="horizontal">
          <div className="mt-12 w-128">
            {destination != null &&
              TypeGuards.AcceleratedChainExpansion.isSupportedChainId(
                aceBlockchain?.chainId,
              ) && (
                <SelectAmountForm
                  chainId={aceBlockchain.chainId}
                  chainName={aceBlockchain.name}
                  destination={destination}
                />
              )}
          </div>
        </Center>
      </Center>
    </FullScreen>
  )
}
